import ViewContext from '../../context/view/Context'
import OthersList from './OthersList'
import React from 'react'

const list = <OthersList />

const Others: React.FC = () => {
  const { layers: { others, borderPoints } } = React.useContext(ViewContext)

  return (
    others ? <div style={borderPoints ? { opacity: 0.5 } : undefined}>
      {list}
    </div> : null
  )
}

export default Others